<script lang="ts" setup>
import { Button } from '@forgd/ui-kit/button'
import { Dialog, DialogContent } from '@forgd/ui-kit/dialog'
import { liquidityNavTools } from '../utils/nav'
// TODO use core-dashboard

withDefaults(defineProps<Options>(), { contact: true, containerClass: 'max-w-[1200px]', containerLayout: 'center' })

interface Options {
  title?: string
  icon?: string
  cta?: string
  contact?: boolean
  containerClass?: false | string
  containerLayout?: 'center' | 'fluid'
}

useHead({
  templateParams: {
    siteName: 'Forgd Liquidity',
  },
})

const router = useRouter()
const searchTerm = ref('')
const { isContentSearchModalOpen } = useUIState()
const showSupportModal = useSupportModal()

const groups = [
  {
    key: 'tools',
    label: 'Liquidity Tools',
    commands: liquidityNavTools,
  },
]

const displayFooter = computed(() => {
  const availableRoutes = [
    '/active-rfqs',
    '/closed-rfqs',
    '/market-maker-leaderboard',
    '/market-maker-leaderboard/depth',
    '/market-maker-leaderboard/volume',
    '/market-maker-leaderboard/spread',
    '/market-maker-leaderboard/kpi',
    '/market-maker-leaderboard/documentation',
    '/monitor-active-projects',
    '/my-active-engagements',
    '/reports-history',
    '/api-keys',
    '/settings',
    '/settings/leaderboard-opt-ins',
    '/settings/notifications',
  ]
  return availableRoutes.includes(router.currentRoute.value.path)
})

function openSupportModal() {
  showSupportModal.value = true
}

function closeSupportModal() {
  showSupportModal.value = false
}
</script>

<template>
  <NuxtLayout name="core-dashboard" v-bind="$props">
    <template v-if="$slots['mobile-header']" #mobile-header>
      <slot name="mobile-header" />
    </template>
    <template v-if="$slots.subheader" #subheader>
      <slot name="subheader" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #header-notifications>
      <CoreAppNotifications />
    </template>
    <template #nav>
      <AppNav />
    </template>
    <template v-if="$slots.sidebar" #sidebar>
      <slot name="sidebar" />
    </template>
    <template v-if="$slots['right-sidebar']" #right-sidebar>
      <slot name="right-sidebar" />
    </template>
    <template v-if="displayFooter" #footer>
      <div class="px-[1.875rem] py-[3.125rem] border-t border-default w-full mx-auto">
        <div class="flex max-w-[1200px] mx-auto ">
          <div class="w-8/12">
            <slot name="footer" />
            <div v-if="!$slots.footer">
              <p class="text-accent text-base font-semibold mb-4">
                Build Your Reputation
              </p>
              <p class="text-primal leading-tight text-4xl font-normal mb-8">
                Streamline your operations & improve your Leaderboard rank by providing data to Forgd.
              </p>
              <div class="flex flex-col gap-1 items-start">
                <div class="text-sm">
                  Need Support?
                </div>
                <Button size="lg" @click="openSupportModal">
                  Get in touch with Forgd
                </Button>
              </div>
            </div>
          </div>
          <div class="flex justify-end items-center w-4/12">
            <img src="/cubes.svg" alt="Cubes" class="w-[13.5rem]" loading="lazy">
          </div>
        </div>
      </div>
    </template>
    <slot />
    <Dialog :open="showSupportModal" @update:open="(open) => !open && closeSupportModal()">
      <DialogContent class="sm:max-w-[30rem]">
        <div class="flex flex-col items-start gap-2.5 py-1">
          <img src="../public/telegram.svg" class="h-[6.875rem]" alt="Telegram">
          <div class="text-xl text-primary-900 font-semibold">
            Connect with Forgd on Telegram
          </div>
          <p class="text-sm text-gray-600">
            Get support, share feedback, and more through your dedicated Telegram support channel. Reach out to us anytime!
          </p>
          <Button as-child size="md" class="w-full mt-2.5">
            <NuxtLink to="https://t.me/+G3a5lwRFo5RiNmE1" target="_blank" @click="closeSupportModal">
              Open Telegram
            </NuxtLink>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  </NuxtLayout>
  <ClientOnly>
    <LazyCoreSearchModal v-model="searchTerm" v-model:is-open="isContentSearchModalOpen" :groups="groups" />
  </ClientOnly>
</template>
